import { defaultLanguages, LANGUAGES, STORES } from './config';

export const getLanguage = () => {
  switch (defaultLanguages) {
    case STORES.ru:
      return LANGUAGES.ru;
    case STORES.kz:
      return LANGUAGES.ru;
    case STORES.ae:
    case STORES.qa:
    case STORES.sa:
      return LANGUAGES.en;
    default:
      return LANGUAGES.ru;
  }
};
